import { AnswersItem } from '../__generated__/graphql';

// Full set of answer keys initialized to null
export const DEFAULT_ANSWERS: AnswersItem = {
  ip1: null,
  ip2: null,
  ip3: null,
  ip4: null,
  ip5: null,
  ip6: null,
  ip7: null,
  ip8: null,
  ip9: null,
  ip10: null,
  ip11: null,
  ip12: null,
  ip13: null,
  ip14: null,
  ip15: null,
  ip16: null,
  ip17: null,
  ip18: null,
  ip19: null,
  ip20: null,
  ip21: null,
  ip22: null,
  ip23: null,
  ip24: null,
  ip25: null,
  ip26: null,
  ip27: null,
  ip28: null,
  ip29: null,
  ip30: null,
  p1a: null,
  p2: null,
  p3: null,
  p4: null,
  p5: null,
  p6: null,
  p7: null,
  p8: null,
  p9: null,
  p10: null,
  p11: null,
  p12: null,
  p13: null,
  p14: null,
  p15a: null,
  p16a: null,
  p17: null,
  p18: null,
  p19a: null,
  p20b: null,
  yv2: null,
  yv4: null,
  yv5: null,
  yv8: null,
  yv12: null,
  yv21a: null,
  yv23: null,
  yv26: null,
  yv28: null,
  yv29: null,
  yv32: null,
  yv33: null,
  yv34: null,
  yv37: null,
  yv38: null,
};
